import CampusPage from './CampusPage';
import { CAMPUS_DATA } from '../../data/campus';

export default function MasBuga() {
  return <CampusPage campus={CAMPUS_DATA.bugambilias} />;
}
